/**
 * Componente Login que permite llevar a cabo todas las operación de Login de la aplicación
 */

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Input, Button, Checkbox, notification } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

import { AUTH } from '../../../application/types';
import { email } from '../../actions/auth/email';
import { ModalRecoveryPassword } from './modal_recovery';
import { ModalTotp } from './modal_totp';
import '../styles/login.scss';


const FormItem = Form.Item;
const LogoCompany = 'https://firebasestorage.googleapis.com/v0/b/gestor-documental-67434.appspot.com/o/Cabezote_Web_CR.gif?alt=media&token=71d4c061-1cd3-4ed7-b23c-ee25f5c2c916';

/**
 *
 * Exporta el componente Login
 */
export const Login = () => {

  // Funcion que permite ejecutar todas las acciones del estado de redux
  const dispatch = useDispatch();
  // Manejo de los estados del componente
  // ?forgot=1 (desde /reset-password con enlace vencido) abre el modal directo.
  // El flag se consume una sola vez: se limpia de la URL para que un logout
  // posterior no re-abra el modal.
  const [visible, setVisible] = useState(
    new URLSearchParams(window.location.search).get('forgot') === '1'
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (new URLSearchParams(window.location.search).get('forgot') === '1') {
      window.history.replaceState(null, '', '/');
    }
  }, []);

  // Hook para el control de los formularios
  const [form] = Form.useForm();

  // Metodo que autentica al usuario
  const onFinish = values => {
    setLoading(true);
    dispatch( email( values.email, values.password ) ).then( res => {
      setLoading(false);
      if ( res && res.type === AUTH.ERROR ) {
        notification.warning({
          message: 'Credenciales invalidas',
          description: 'Verifique su direccion de correo o contraseña',
          placement:  'topRight'
        });
      }
    });
  };

  /**
   * Metodo que renderiza el componente
   */
  return (
    <div className  = 'cuerpo' >

      <div className  = 'imagenInicio' >
        <img alt = "logo" src = { LogoCompany } />
      </div>
      <div className = 'login' >
      
        <Form form = { form } className = "login-form" onFinish = { onFinish } >

          <FormItem name = "email" help = "example@example.com"
            rules = {[
              { required: true, message: 'Debe ingresar una direccion de correo' },
              { type: 'email', message: 'Debe ingresar una direccion de correo valida' }
            ]} >
            <Input prefix = { <UserOutlined style = {{ color: 'rgba(0,0,0,.25)' }} /> } type = 'email' placeholder = "Email" />
          </FormItem>
          <FormItem name = "password"  help = "Minimo 6 caracteres"
            rules = {[{ required: true, message: 'Debe ingresar minimo 6 caracteres!' }]} >
            <Input prefix = { <LockOutlined style = {{ color: 'rgba(0,0,0,.25)' }} /> } type = "password" placeholder = "Password" />
          </FormItem>
          <FormItem valuePropName = "checked" initialValue = { true } >
            <Checkbox> Recordarme </Checkbox>
            <Button type = "link" className = "login-form-forgot"
              onClick = { e => {
                e.preventDefault();
                setVisible(true);
              }} > ¿Olvidó su contraseña? </Button>
            <Button type = "primary" htmlType = "submit" className = "login-form-button" loading = { loading } > Iniciar sesion </Button>
          </FormItem>
        </Form>

        <ModalRecoveryPassword visible = { visible } setVisible = { setVisible } />

        {/* Se abre solo cuando el sign-in exige el código TOTP
            (auth.type === AUTH.MFA_TOTP_REQUIRED) */}
        <ModalTotp />

      </div>
    </div>
  );
};